export const Loading = () => {
    return (<div className='loader'></div>)
};
